// assets/cart-recommendations.js

(function () {
  const CARD_SELECTOR = '.cart-drawer__recommendations-grid .cp-card';
  const VARIANTS_JSON_SELECTOR = '.cp-variants-json';
  const SWATCH_INPUT_SELECTOR = '.cp-swatch__input';
  const BAG_BUTTON_SELECTOR = '.cp-bag-toggle';

  // Cache local dos variants por card
  const variantsCache = new WeakMap();

  function getCard(element) {
    return element.closest('.cp-card');
  }

  function parseVariants(card) {
    if (!card) return null;

    if (variantsCache.has(card)) {
      return variantsCache.get(card);
    }

    const jsonEl = card.querySelector(VARIANTS_JSON_SELECTOR);
    if (!jsonEl) return null;

    try {
      const data = JSON.parse(jsonEl.textContent.trim());
      variantsCache.set(card, data);
      return data;
    } catch (e) {
      console.error('[cart-recommendations] Erro ao parsear cp-variants-json', e);
      return null;
    }
  }

  function formatMoney(cents) {
    try {
      if (window.Shopify && typeof Shopify.formatMoney === 'function') {
        // Se o tema tiver format configurado, usa ele
        const moneyFormat =
          (window.theme && window.theme.moneyFormat) ||
          'R${{amount_no_decimals_with_comma_separator}}';
        return Shopify.formatMoney(cents, moneyFormat);
      }
    } catch (e) {
      console.warn('[cart-recommendations] Erro no Shopify.formatMoney, usando fallback.', e);
    }

    // Fallback simples em R$
    const value = (cents / 100).toFixed(2).replace('.', ',');
    return 'R$ ' + value;
  }

  // Usa o índice de cor do card (data-color-index), se existir
  function findVariantByColor(card, variants, colorName) {
    if (!variants || !Array.isArray(variants)) return null;
    if (!colorName) return variants[0] || null;

    let colorIndex = 0;
    if (card && card.dataset && card.dataset.colorIndex !== undefined) {
      const raw = card.dataset.colorIndex;
      if (raw !== '' && raw != null) {
        const n = Number(raw);
        if (!Number.isNaN(n) && n >= 0) {
          colorIndex = n;
        }
      }
    }

    const byOption = variants.find(
      (v) => Array.isArray(v.options) && v.options[colorIndex] === colorName
    );
    return byOption || variants[0] || null;
  }

  function updateCardUIForVariant(card, variant) {
    if (!card || !variant) return;
  
    const img = card.querySelector('.cp-img--primary');
    if (img && variant.featured_media_url) {
      img.src = variant.featured_media_url;
  
      // Atualiza também o srcset/sizes para bater com o padrão do card-product
      try {
        const base = String(variant.featured_media_url || '');
  
        // transforma ..._800x.webp em ..._200x.webp, ..._400x.webp etc
        const withSize = (u, size) => u.replace(/_(\d+)x\./, `_${size}x.`);
  
        const s200 = withSize(base, 200);
        const s400 = withSize(base, 400);
        const s600 = withSize(base, 600);
        const s800 = withSize(base, 800);
  
        img.srcset = `${s200} 200w, ${s400} 400w, ${s600} 600w, ${s800} 800w`;
        img.sizes = '(max-width: 768px) 88vw, (max-width: 1200px) 400px, 600px';
  
        if (img.decode) {
          img.decode().catch(() => {});
        }
      } catch (e) {
        // se der algum erro, seguimos só com o src mesmo
      }
    }
  
    const priceEl = card.querySelector('.cp-price__current');
    const compareEl = card.querySelector('.cp-price__compare');
  
    if (priceEl && typeof variant.price === 'number') {
      priceEl.textContent = formatMoney(variant.price);
    }
  
    if (compareEl) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        compareEl.textContent = formatMoney(variant.compare_at_price);
        compareEl.hidden = false;
      } else {
        compareEl.hidden = true;
      }
    }
  
    // Atualiza links para apontar para a variant selecionada
    const mediaLink = card.querySelector('.cp-media');
    const titleLink = card.querySelector('.cp-title a');
  
    if (mediaLink || titleLink) {
      let baseProductUrl = card.dataset.baseProductUrl || null;
  
      if (!baseProductUrl) {
        const sourceLink = mediaLink || titleLink;
        const href = sourceLink && sourceLink.getAttribute('href');
  
        if (href) {
          try {
            const url = new URL(href, window.location.origin);
            url.search = '';
            url.hash = '';
            baseProductUrl = url.toString();
          } catch (e) {
            baseProductUrl = href;
          }
          card.dataset.baseProductUrl = baseProductUrl;
        }
      }
  
      if (baseProductUrl && variant.id) {
        const separator = baseProductUrl.indexOf('?') === -1 ? '?' : '&';
        const variantUrl = `${baseProductUrl}${separator}variant=${encodeURIComponent(
          variant.id
        )}`;
  
        if (mediaLink) mediaLink.href = variantUrl;
        if (titleLink) titleLink.href = variantUrl;
      }
    }
  
    // guarda a variant selecionada no card
    card.dataset.selectedVariantId = String(variant.id);
  }
  

  function ensureSelectedVariant(card) {
    if (!card) return null;

    // se já tiver selecionada, usa ela
    if (card.dataset.selectedVariantId) {
      const variants = parseVariants(card);
      if (!variants) return null;
      const v = variants.find((v) => String(v.id) === card.dataset.selectedVariantId);
      if (v) return v;
    }

    const variants = parseVariants(card);
    if (!variants || !variants.length) return null;

    const checkedSwatch = card.querySelector(`${SWATCH_INPUT_SELECTOR}:checked`);
    let colorName = null;

    if (checkedSwatch) {
      colorName = checkedSwatch.value || checkedSwatch.dataset.colorName;
    }

    const variant = findVariantByColor(card, variants, colorName);
    if (!variant) return null;

    card.dataset.selectedVariantId = String(variant.id);
    return variant;
  }

  // Troca de cor (swatch -> imagem + preço + link)
  document.addEventListener('change', function (event) {
    const input = event.target.closest(SWATCH_INPUT_SELECTOR);
    if (!input) return;

    const card = getCard(input);
    if (!card || !card.matches(CARD_SELECTOR)) return;

    const colorName = input.value || input.dataset.colorName;
    const variants = parseVariants(card);
    if (!variants) return;

    const variant = findVariantByColor(card, variants, colorName);
    if (!variant) return;

    updateCardUIForVariant(card, variant);
  });

  // ===== Helper para pegar a quantidade atual no carrinho em tempo real =====
  async function getCurrentQtyInCart(variantId) {
    try {
      const res = await fetch("/cart.js", {
        headers: { Accept: "application/json" },
      });
      if (!res.ok) return 0;
      const data = await res.json();
      const items = data.items || [];
      const found = items.find(
        (it) => String(it.variant_id) === String(variantId)
      );
      return found ? Number(found.quantity || 0) : 0;
    } catch (e) {
      return 0;
    }
  }

  // Clique na sacola -> adiciona ao carrinho
  document.addEventListener('click', async function (event) {
    const btn = event.target.closest(BAG_BUTTON_SELECTOR);
    if (!btn) return;

    const card = getCard(btn);
    if (!card || !card.matches(CARD_SELECTOR)) return;

    const variants = parseVariants(card);
    if (!variants || !variants.length) return;

    let variant = ensureSelectedVariant(card);
    if (!variant) {
      variant = variants[0];
      card.dataset.selectedVariantId = String(variant.id);
    }

    const variantId = String(variant.id);
    if (!variantId) return;

    // Evita clique se já estiver carregando
    if (btn.dataset.loading === 'true') return;

    // Verificação de estoque preliminar (local)
    const invQtyRaw = variant.inventory_quantity;
    const invQty = typeof invQtyRaw === 'number' ? invQtyRaw : parseInt(invQtyRaw || '0', 10);
    const invPolicy = variant.inventory_policy || 'deny';

    if (invPolicy === 'deny' && (!invQty || invQty <= 0)) {
      if (window.showToast) {
        window.showToast('Este tamanho está indisponível no momento.', {
          type: 'warning',
          duration: 3000
        });
      }
      return;
    }

    // Estado de loading no botão
    btn.disabled = true;
    btn.dataset.loading = 'true';
    btn.classList.add('is-loading'); // ✅ Classe CSS para o spinner

    try {
      // Verifica quantidade no carrinho (servidor)
      const currentInCart = await getCurrentQtyInCart(variantId);

      if (invPolicy === 'deny' && invQty > 0 && currentInCart >= invQty) {
        if (window.showToast) {
          window.showToast('Você já possui a quantidade máxima deste item no carrinho.', {
            type: 'warning',
            duration: 3500
          });
        }
        return;
      }

      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', '1');

      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          Accept: 'application/json'
        },
        body: formData
      });

      if (!res.ok) {
        try {
          const err = await res.json();
          const msg = err && err.description ? String(err.description) : 'Erro ao adicionar ao carrinho';
          if (window.showToast) {
            window.showToast(msg, { type: 'warning', duration: 3500 });
          }
        } catch (_) {
          if (window.showToast) {
            window.showToast('Não foi possível adicionar este item ao carrinho.', { type: 'warning', duration: 3500 });
          }
        }
        return; // Aborta fluxo de sucesso
      }

      await res.json(); // Consome corpo da resposta

      // dispara evento genérico (se quiser usar em outro lugar)
      document.dispatchEvent(
        new CustomEvent('cart:updated', {
          bubbles: true,
          detail: { source: 'cart-recommendations' }
        })
      );

      // usa a API REAL do drawer
      if (window.CART_DRAWER && typeof window.CART_DRAWER.reload === 'function') {
        window.CART_DRAWER.reload();
      }

    } catch (err) {
      console.error('[cart-recommendations] Falha ao adicionar item ao carrinho', err);
      if (window.showToast) {
        window.showToast('Erro de conexão ao adicionar produto.', { type: 'error', duration: 3000 });
      }
    } finally {
      btn.disabled = false;
      delete btn.dataset.loading;
      btn.classList.remove('is-loading'); // ✅ Remove classe CSS
    }
  });

  // Inicialização básica: garante que cada card tenha uma variant setada
  function initCards() {
    const cards = document.querySelectorAll(CARD_SELECTOR);
    cards.forEach(function (card) {
      ensureSelectedVariant(card);
    });
  }

  // expõe uma API global pro drawer poder chamar depois de reload
  window.CART_RECOMMENDATIONS = {
    refresh: initCards
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCards);
  } else {
    initCards();
  }
})();
